import { defineMessages } from "react-intl";
const messages = defineMessages({
    aiDiscoverabilityResultsPlaceholder: {
        id: "app.admin.aiDiscoverability.resultsPlaceholder",
        defaultMessage: "Yours results will appear here!",
    },
});
export default messages;
